<app-grid
    [columns]="columns"
    [rows]="data.tableRows"
    [tableParams]="data.tableParams"
    [multiSelect]="false"
    [gridName]="gridName"
    (refreshDataFromServer)="refreshData($event)"
   (rowSelected)="onRowClick($event)"
></app-grid>
